import { gql } from "@apollo/client";

export const NOTIFICATIONS = gql`
  query Notifications($where: NotificationWhereInput, $take: Int, $skip: Int) {
    notifications(where: $where, take: $take, skip: $skip) {
      data {
        id
        content
        createdDate
      }
      count
    }
  }
`;

const notifications = { NOTIFICATIONS };

export default notifications;
